import { Components, Theme } from '@mui/material/styles';

declare module '@mui/material/SvgIcon' {
  interface SvgIconPropsColorOverrides {
    oceanTint: true;
    sandShade2: true;
    taigaTint1: true;
    forest: true;
    sand: true;
    taiga: true;
    ocean: true;
    desert: true;
  }
}

export default function MuiSvgIcon(theme: Theme): Components['MuiSvgIcon'] {
  return {};
}
